import type { ReactNode } from "react";
import { BillingStatusContext } from "./BillingStatusContext";
import { useBillingAccess } from "./hooks";

export function BillingStatusProvider({ children }: { children: ReactNode }) {
  const billing = useBillingAccess();
  return <BillingStatusContext.Provider value={billing}>{children}</BillingStatusContext.Provider>;
}
